import React, { useState, useEffect } from 'react';
import PrototypePage from './pages/PrototypePage';

function App() {
  const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
  // Speichern des Prototyp-Status im localStorage, damit dieser nach Redirect erhalten bleibt
  const [showPrototype, setShowPrototype] = useState(() => {
    const saved = localStorage.getItem('showPrototype');
    return saved === 'true';
  });

  // Aktualisieren des localStorage wenn sich showPrototype ändert
  useEffect(() => {
    localStorage.setItem('showPrototype', showPrototype.toString());
  }, [showPrototype]);

  // Timer für die Live-Uhr
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  // Überprüfen des URL-Fragments für Magic Link Auth
  useEffect(() => {
    // Überprüfen, ob wir von einem Auth-Redirect kommen
    const fragment = window.location.hash;
    if (fragment.includes('access_token') || fragment.includes('error')) {
      // Wir sind von einem Magic Link zurückgekommen
      // Wir können showPrototype auf true setzen, falls noch nicht geschehen
      setShowPrototype(true);
      
      // Fragment aus URL entfernen nach Verarbeitung
      if (window.history.replaceState) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    }
  }, []);

  if (showPrototype) {
    return (
      <div>
        <button 
          onClick={() => setShowPrototype(false)}
          className="absolute top-4 left-4 px-3 py-1 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 z-10"
        >
          ← Zurück
        </button>
        <PrototypePage />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <h1 className="text-2xl font-bold text-center text-blue-600 mb-6">
          Dentalytics
        </h1>
        <p className="text-gray-700 mb-4">
          Willkommen bei Dentalytics - der Analytics-Plattform für Zahnarztpraxen.
        </p>
        <p className="text-gray-700 mb-4">
          Wähle einen Bereich, um fortzufahren:
        </p>
        <div className="mt-4 p-3 bg-blue-50 rounded text-sm text-blue-800">
          Database: PostgreSQL (Port 7010)
        </div>
        <div className="mt-4 p-3 bg-green-50 rounded text-sm text-green-800">
          Live-Uhr: {currentTime}
        </div>
        <div className="mt-6 space-y-4">
          <button
            onClick={() => setShowPrototype(true)}
            className="w-full text-center bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded"
          >
            Dentalytics Dashboard
          </button>
          <a href="http://85.215.196.176:7013" className="block text-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
              Prisma Studio öffnen
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
